import { createAction, props } from '@ngrx/store';
import { ProjectCarrierMapDTO } from 'cargo-chief-commons';

export const PROJECT_CARRIER_MAP = {
	SET: {
		ENGAGED_CARRIERS_COUNT: createAction(
			'[Project details] Set enggaged carriers count',
			props<{ total: number }>()
		),
		PROCURED_CARRIERS_COUNT: createAction(
			'[Project details] Set procured carriers count',
			props<{ total: number }>()
		),
		PROCURED_CARRIERS_WITHOUT_COUNT: createAction(
			'[Project details] Set procured carriers without group count',
			props<{ total: number }>()
		),

		ENGAGED_CARRIERS_LIST: createAction(
			'[Project details] Set engaged carriers list',
			props<{ list: ProjectCarrierMapDTO[] }>()
		),
		PROCURED_CARRIERS_LIST: createAction(
			'[Project details] Set procured carriers list',
			props<{ list: ProjectCarrierMapDTO[] }>()
		),
		ALL_PROJECT_CARRIER_MAPS_LIST: createAction(
			'[Project details] Set all project carriers maps list',
			props<{ list: ProjectCarrierMapDTO[] }>()
		),
	},

	GET_ALL: createAction('[Project details] Get all project carrier maps', props<any>()),
	GET_ALL_SUCCESS: createAction(
		'[Project details] Get all project carrier maps success',
		props<any>()
	),
	GET_ALL_FAILURE: createAction(
		'[Project details] Get all project carrier maps failure',
		props<{ payload: { message: string } }>()
	),

	LANES: {
		ACCOUNT_CARRIER: {
			GET: createAction('[Project details] Get account carriers lanes', props<any>()),
			SUCCESS: createAction('[Project details] Get account carriers lanes success', props<any>()),
			FAILURE: createAction(
				'[Project details] Get account carriers lanes failure',
				props<{ payload: { message: string } }>()
			),
		},
		CARRIER: {
			GET: createAction('[Project details] Get carriers lanes', props<any>()),
			SUCCESS: createAction('[Project details] Get carriers lanes success', props<any>()),
			FAILURE: createAction(
				'[Project details] Get carriers lanes failure',
				props<{ payload: { message: string } }>()
			),
		},
	},

	DELETE_PROJECT_CARRIER_MAP: {
		START: createAction('[Project details] Start removing carriers from project', props<any>()),
		DELETE: createAction('[Project details] Delete project carriers map', props<any>()),
		SUCCESS: createAction('[Project details] Delete project carriers map success', props<any>()),
		FAILURE: createAction(
			'[Project details] Delete project carriers map failure',
			props<{ payload: { message: string } }>()
		),
		OPEN_DIALOG: createAction(
			'[Project details] Open note when removing carrier from engaged',
			props<any>()
		),
	},

	ENGAGE_TO_PROCURE: {
		CREATE: createAction('[Project details] Move carrier from engaged to procure', props<any>()),
		SUCCESS: createAction(
			'[Project details] Move carrier from engaged to procure success',
			props<any>()
		),
		FAILURE: createAction(
			'[Project details] Move carrier from engaged to procure failure',
			props<{ payload: { message: string } }>()
		),
		RATE_DIALOG: {
			OPEN: createAction(
				'[Project details] Open rate dialog when moving carrier from engaged to procure',
				props<any>()
			),
			CLOSE: createAction(
				'[Project details] Close rate dialog when moving carrier from engaged to procure',
				props<any>()
			),
		},
	},

	PROCURED_TO_ENGAGED: {
		CREATE: createAction('[Project details] Move carrier from procured to engaged', props<any>()),
		SUCCESS: createAction(
			'[Project details] Move carrier from procured to engaged success',
			props<any>()
		),
		FAILURE: createAction(
			'[Project details] Move carrier from procured to engaged failure',
			props<{ payload: { message: string } }>()
		),
	},

	PROCURED: {
		DELETE: createAction('[Project details] Delete procured project carriers maps', props<any>()),
		DELETE_SUCCESS: createAction(
			'[Project details] Delete procured project carriers maps success',
			props<any>()
		),
		DELETE_FAILURE: createAction(
			'[Project details] Delete procured project carriers maps failure',
			props<{ payload: { message: string } }>()
		),
	},

	FILTER: {
		APPLY: createAction('[Project details] Filter by truck count', props<any>()),
		COMPLETE: createAction('[Project details] Filter on carrier fields completed', props<any>()),
	},

	UPDATE_RATE: {
		OPEN_DIALOG: createAction('[Project details] update carrier rate  open dialog', props<any>()),
		CLOSE_DIALOG: createAction('[Project details] update carrier rate  close dialog', props<any>()),
		UPDATE: createAction('[Project details] update carrier rate ', props<any>()),
		SUCCESS: createAction('[Project details] updated carrier rate ', props<any>()),
		FAILURE: createAction('[Project details] update carrier rate failed', props<any>()),
	},
};
